// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"c35eb75f","167":"31d6cfe0","360":"4b87919e","390":"59fd20ce","476":"ac041f2a","968":"59fd20ce","996":"6df84c47"}[chunkId] + ".chunk.css";
};